import React from "react";
import useConfigurable from "../hooks/configurable-fields";

const ConfigurableFieldsContext = React.createContext(null);

export const ConfigurableFieldsProvider = ({ children }) => {
  const value = useConfigurable();

  return (
    <ConfigurableFieldsContext.Provider value={value}>
      {children}
    </ConfigurableFieldsContext.Provider>
  );
};

export const useConfigurableFields = () => React.useContext(ConfigurableFieldsContext);
